import { createAction } from 'typesafe-actions';
import { SupportedLanguage } from 'translation';

export const changeName = createAction('CHANGE_NAME', (name: string) => ({
  name,
}))();

export const fetchName = createAction('FETCH_NAME', (name: string) => ({
  name,
}))();

export const fetchToken = createAction(
  'FETCH_TOKEN',
  ({ mail, password }: { mail: string; password: string }) => ({
    mail,
    password,
  }),
)();

export const updateToken = createAction('UPDATE_TOKEN', (token: string) => ({
  token,
}))();

export const logout = createAction('LOGOUT')();

export const dispatchAuthError = createAction(
  'NEW_ERROR',
  (errorMessage: string) => ({
    errorMessage,
  }),
)();

export const dispatchAdminPasswordError = createAction(
  'NEW_ERROR_ADMIN_PASSWORD',
  (errorMessage: string) => ({
    errorMessage,
  }),
)();

export const flushAdminPopup = createAction('FLUSH_ADMIN_POPUP')();

export const changeLanguage = createAction(
  'CHANGE_LANGUAGE',
  (language: SupportedLanguage) => ({
    language,
  }),
)();

export const enterCharForAdminPassword = createAction(
  'ENTER_PASSWORD',
  (character: string) => ({
    character,
  }),
)();

export const resetTypedAdminPassword = createAction('RESET_TYPED_PASSWORD')();
